<!-- Estilos: sistema .lx-* (_liga-ui.scss) + .lxd-* (_liga-d.scss); el .scss del componente solo lleva :host. -->
<p class="lx-sr" role="status" aria-live="polite">{{anuncio}}</p>

<!-- Cargando la oferta: esqueleto en lugar de la pantalla en blanco -->
<section class="lx-pagina" lang="es" *ngIf="cargando" aria-busy="true" aria-label="Cargando tu oferta">
  <div class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-esqueleto lx-esqueleto--icono"></span>
      <div class="lx-hero__textos lx-pila lx-pila--chica">
        <span class="lx-esqueleto lx-esqueleto--corto"></span>
        <span class="lx-esqueleto lx-esqueleto--titulo"></span>
        <span class="lx-esqueleto"></span>
      </div>
    </div>
    <div class="lx-hero__pie"><span class="lx-esqueleto"></span></div>
  </div>
  <div class="lx-tarjeta lx-pila">
    <span class="lx-esqueleto lx-esqueleto--corto"></span>
    <span class="lx-esqueleto lx-esqueleto--bloque"></span>
    <span class="lx-esqueleto"></span>
  </div>
</section>

<!-- No se pudo cargar la oferta -->
<section class="lx-pagina" lang="es" *ngIf="!cargando && errorCarga">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono lx-hero__icono--navy" aria-hidden="true"><fa-icon [icon]="iconos.oferta"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Tu oferta</span>
        <h2 class="lx-hero__titulo">No pudimos cargar tu oferta</h2>
        <p class="lx-hero__subtitulo">Tu información está a salvo. Vuelve a intentarlo en un momento.</p>
      </div>
    </div>
  </header>
  <div class="lx-alerta lx-alerta--error" role="alert">
    <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
    <div class="lx-alerta__cuerpo">
      <p class="lx-alerta__titulo">Algo salió mal</p>
      <p class="lx-alerta__texto">{{errorCarga}}</p>
      <button type="button" class="lx-btn lx-btn--secundario lx-btn--chico lx-btn--auto lx-alerta__accion" (click)="getOffers()">
        <fa-icon [icon]="iconos.reintentar" aria-hidden="true"></fa-icon><span>Reintentar</span>
      </button>
    </div>
  </div>
</section>

<!-- No elegible: las reglas de crédito de la nómina (antigüedad o edad) no le
     permiten pedir un crédito hoy. El mensaje es el del servidor (422 NO_ELEGIBLE). -->
<section class="lx-pagina" lang="es" #estadoNoElegible *ngIf="!cargando && noElegible as ne">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono lx-hero__icono--navy" aria-hidden="true"><fa-icon [icon]="iconos.noElegible"></fa-icon></span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Tu oferta</span>
        <h2 class="lx-hero__titulo">Por ahora no puedes solicitar un crédito</h2>
        <p class="lx-hero__subtitulo">{{ne.mensaje}}</p>
        <p class="lx-hero__subtitulo" *ngFor="let otro of otrosBloqueos">{{otro}}</p>
      </div>
    </div>
  </header>
  <section class="lx-tarjeta lxd-no-elegible" aria-labelledby="ofr-no-elegible-que-hacer">
    <h3 class="lx-tarjeta__titulo" id="ofr-no-elegible-que-hacer">¿Qué puedes hacer?</h3>
    <ol class="lx-lista lx-lista--numerada">
      <li *ngIf="noElegiblePorTiempo">Cuando cumplas el requisito, vuelve a intentarlo.</li>
      <li>Si crees que hay un error en tus datos (como tu fecha de ingreso o de nacimiento), contáctanos a soporte.</li>
    </ol>
    <div class="lx-cta">
      <button type="button" class="lx-btn lx-btn--primario" (click)="understand()"><span>Entendido</span></button>
    </div>
  </section>
</section>

<ng-container *ngIf="!cargando && entity && !noElegible">
  <ng-container *ngIf="max > 0; else elseComment;">
    <form class="lx-pagina lx-pagina--con-cta" lang="es" [formGroup]="entity" (ngSubmit)="alEnviar()" novalidate>

      <!-- Encabezado: qué se decide aquí y en qué etapa vas -->
      <header class="lx-hero">
        <div class="lx-hero__cabeza">
          <span class="lx-hero__icono" aria-hidden="true"><fa-icon [icon]="iconos.oferta"></fa-icon></span>
          <div class="lx-hero__textos">
            <span class="lx-hero__eyebrow">Oferta preautorizada</span>
            <ng-container [ngSwitch]="etapa">
              <ng-container *ngSwitchCase="0">
                <h2 class="lx-hero__titulo">¿Cuánto necesitas?</h2>
                <p class="lx-hero__subtitulo">Puedes pedir desde <strong>{{min | currency:'MXN'}}</strong> hasta <strong>{{max | currency:'MXN'}}</strong>.</p>
              </ng-container>
              <ng-container *ngSwitchCase="1">
                <h2 class="lx-hero__titulo">Elige en cuántos pagos</h2>
                <p class="lx-hero__subtitulo">Para <strong>{{montoCalculado | currency:'MXN'}}</strong> tienes {{offers.length}} {{offers.length === 1 ? 'opción' : 'opciones'}}.</p>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                <h2 class="lx-hero__titulo">Revisa y acepta tu oferta</h2>
                <p class="lx-hero__subtitulo" *ngIf="elegida as o"><strong>{{o.plazo}}</strong> de <strong>{{o.cuota | currency:'MXN'}}</strong>. Si te convence, acéptala.</p>
              </ng-container>
            </ng-container>
            <span class="lx-chip" *ngIf="data.comment && data.comment !== ''" [ngClass]="estados.corrige.chip">
              <fa-icon *ngIf="estados.corrige.icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
            </span>
          </div>
        </div>
        <div class="lx-hero__pie">
          <ol class="lx-etapas" [attr.aria-label]="'Parte ' + (etapa + 1) + ' de 3'">
            <li [ngClass]="claseEtapa(0)" [attr.aria-current]="etapa === 0 ? 'step' : null">
              <span class="lx-etapas__barra" aria-hidden="true"></span>
              <span class="lx-etapas__texto">
                <span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="etapa > 0; else uno" [icon]="iconos.listo"></fa-icon><ng-template #uno>1</ng-template></span>Monto
              </span>
            </li>
            <li [ngClass]="claseEtapa(1)" [attr.aria-current]="etapa === 1 ? 'step' : null">
              <span class="lx-etapas__barra" aria-hidden="true"></span>
              <span class="lx-etapas__texto">
                <span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="etapa > 1; else dos" [icon]="iconos.listo"></fa-icon><ng-template #dos>2</ng-template></span>Plazo
              </span>
            </li>
            <li [ngClass]="claseEtapa(2)" [attr.aria-current]="etapa === 2 ? 'step' : null">
              <span class="lx-etapas__barra" aria-hidden="true"></span>
              <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true">3</span>Aceptar</span>
            </li>
          </ol>
        </div>
      </header>

      <!-- Rechazo del paso: amable, con el motivo -->
      <div class="lx-alerta lx-alerta--error" *ngIf="data.comment && data.comment !== ''">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">Necesitamos que vuelvas a elegir tu oferta</p>
          <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
        </div>
      </div>

      <!-- 1. Monto -->
      <section class="lx-tarjeta" aria-labelledby="ofr-monto-etiqueta">
        <div class="lx-campo lxd-monto" [class.is-invalido]="montoInvalido">
          <label class="lx-campo__etiqueta" id="ofr-monto-etiqueta" for="ofr-monto">Monto que necesitas</label>
          <p-inputNumber formControlName="amount" inputId="ofr-monto" mode="currency" currency="MXN" locale="es-MX"></p-inputNumber>
          <p class="lx-campo__error" id="ofr-monto-error" *ngIf="montoInvalido" role="alert">
            <fa-icon [icon]="iconos.error" aria-hidden="true"></fa-icon>
            <span *ngIf="entity.get('amount')?.errors?.['required']">Escribe cuánto necesitas, desde {{min | currency:'MXN'}}.</span>
            <span *ngIf="entity.get('amount')?.errors?.['min']">El mínimo es {{entity.get('amount')?.errors?.['min']['min'] | currency:'MXN'}}. Sube el monto o toca «Mín.».</span>
            <span *ngIf="entity.get('amount')?.errors?.['max']">El máximo es {{entity.get('amount')?.errors?.['max']['max'] | currency:'MXN'}}. Baja el monto o toca «Máx.».</span>
          </p>
          <div class="lxd-rango">
            <input class="lxd-rango__input" type="range" aria-label="Ajusta el monto con la barra"
                   [min]="rangoMin" [max]="rangoMax" [step]="pasoRango" [value]="valorRango"
                   [style.--lxd-pct]="pctRango + '%'" [attr.aria-valuetext]="monto | currency:'MXN'"
                   [disabled]="aplicando" (input)="alDeslizar($event)">
            <div class="lxd-rango__limites">
              <button type="button" class="lxd-rango__limite" [disabled]="aplicando" (click)="usarMonto(min)"
                      [attr.aria-label]="'Usar el mínimo: ' + (min | currency:'MXN')">Mín.<strong>{{min | currency:'MXN'}}</strong></button>
              <button type="button" class="lxd-rango__limite" [disabled]="aplicando" (click)="usarMonto(max)"
                      [attr.aria-label]="'Usar el máximo: ' + (max | currency:'MXN')">Máx.<strong>{{max | currency:'MXN'}}</strong></button>
            </div>
          </div>
          <p class="lx-campo__ayuda" *ngIf="offers.length">Si cambias el monto, vuelves a calcular tus pagos.</p>
        </div>
      </section>

      <!-- El backend no pudo calcular: su mensaje, en línea -->
      <div class="lx-alerta lx-alerta--error" role="alert" *ngIf="errorEn === 'calcular' && mensajeError">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">No pudimos calcular tus pagos</p>
          <p class="lx-alerta__texto">{{mensajeError}}</p>
        </div>
      </div>

      <div class="lx-alerta lx-alerta--aviso" role="status" *ngIf="sinOfertas">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.aviso"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">No hay plazos para este monto</p>
          <p class="lx-alerta__texto">Prueba con un monto menor y vuelve a calcular.</p>
        </div>
      </div>

      <!-- 2. Plazo: calculando -->
      <section class="lx-tarjeta" *ngIf="calculando" aria-busy="true" aria-label="Calculando tus opciones de pago">
        <div class="lx-pila lx-pila--chica">
          <span class="lx-esqueleto lx-esqueleto--titulo"></span>
          <span class="lx-esqueleto lx-esqueleto--corto"></span>
        </div>
        <div class="lx-pila lx-pila--chica" style="margin-top: 14px">
          <div class="lx-esqueleto-paso" *ngFor="let n of [1, 2, 3]">
            <span class="lx-esqueleto lx-esqueleto--circulo"></span>
            <span class="lx-esqueleto-paso__textos"><span class="lx-esqueleto lx-esqueleto--titulo"></span><span class="lx-esqueleto lx-esqueleto--corto"></span></span>
          </div>
        </div>
      </section>

      <!-- 2. Plazo: ofertas comparables -->
      <section class="lx-tarjeta" #seccionOfertas *ngIf="offers.length" aria-labelledby="ofr-plazos-titulo">
        <div class="lx-tarjeta__cabeza">
          <div>
            <h3 class="lx-tarjeta__titulo" id="ofr-plazos-titulo">Elige en cuántos pagos</h3>
            <p class="lx-tarjeta__subtitulo">
              Pagos {{periodoAdjetivo}} para {{montoCalculado | currency:'MXN'}}.
              <ng-container *ngIf="extrasIguales && offers[0].dispersar !== null">Recibes {{offers[0].dispersar | currency:'MXN'}} en tu cuenta.</ng-container>
            </p>
          </div>
          <span class="lx-chip lx-chip--suave">{{offers.length}} {{offers.length === 1 ? 'opción' : 'opciones'}}</span>
        </div>
        <fieldset class="lx-opciones" role="radiogroup" aria-labelledby="ofr-plazos-titulo" [disabled]="aplicando">
          <label class="lx-opcion lxd-oferta" *ngFor="let offer of offers; trackBy: porPlazo; let i = index"
                 [class.is-elegida]="offer === elegida" [class.lxd-oferta--con-chip]="!!offer.etiqueta" [style.animation-delay.ms]="i * 50">
            <input class="lx-opcion__input" type="radio" name="installmentCount" formControlName="installmentCount" [value]="offer"
                   [attr.aria-label]="lecturaOferta(offer)">
            <span class="lx-opcion__marca" aria-hidden="true"></span>
            <span class="lx-opcion__textos" aria-hidden="true">
              <span class="lx-opcion__titulo">{{offer.plazo}}</span>
              <ng-container *ngIf="!extrasIguales">
                <span class="lx-opcion__texto" *ngIf="offer.dispersar !== null">Recibes {{offer.dispersar | currency:'MXN'}}</span>
                <span class="lx-opcion__texto" *ngIf="offer.comision !== null">Comisión {{offer.comision | currency:'MXN'}}</span>
              </ng-container>
            </span>
            <span class="lxd-oferta__cuota" aria-hidden="true">
              <span class="lxd-oferta__monto">{{offer.cuota | currency:'MXN'}}</span>
              <span class="lxd-oferta__periodo">{{offer.porPeriodo}}</span>
            </span>
            <span class="lx-chip lx-chip--suave lxd-oferta__chip" *ngIf="offer.etiqueta" aria-hidden="true">
              <fa-icon [icon]="offer.etiqueta === 'Pago más bajo' ? iconos.pagoBajo : iconos.rapido"></fa-icon>{{offer.etiqueta}}
            </span>
          </label>
        </fieldset>
      </section>

      <!-- 3. Resumen de la oferta elegida -->
      <section class="lx-tarjeta lx-tarjeta--resaltada lxd-resumen" *ngIf="elegida as o" aria-labelledby="ofr-resumen-titulo">
        <div class="lx-tarjeta__cabeza">
          <div>
            <h3 class="lx-tarjeta__titulo" id="ofr-resumen-titulo">Tu oferta</h3>
            <p class="lx-tarjeta__subtitulo">Revísala antes de aceptar.</p>
          </div>
          <span class="lx-chip lx-chip--listo"><fa-icon [icon]="iconos.listo" aria-hidden="true"></fa-icon>Preautorizada</span>
        </div>
        <p class="lx-monto">{{montoCalculado | currency:'MXN'}}<span class="lx-monto__moneda">MXN</span></p>
        <dl class="lx-datos">
          <div class="lx-dato"><dt class="lx-dato__etiqueta">Plazo</dt><dd class="lx-dato__valor">{{o.plazo}}</dd></div>
          <div class="lx-dato"><dt class="lx-dato__etiqueta">Pago {{o.porPeriodo}}</dt><dd class="lx-dato__valor">{{o.cuota | currency:'MXN'}}</dd></div>
          <div class="lx-dato" *ngIf="o.comision !== null"><dt class="lx-dato__etiqueta">Comisión por apertura</dt><dd class="lx-dato__valor">{{o.comision | currency:'MXN'}}</dd></div>
          <div class="lx-dato lx-dato--total" *ngIf="o.dispersar !== null"><dt class="lx-dato__etiqueta">Recibes en tu cuenta</dt><dd class="lx-dato__valor">{{o.dispersar | currency:'MXN'}}</dd></div>
        </dl>
      </section>

      <!-- No se pudo aceptar: el mensaje del backend, junto a la oferta -->
      <div class="lx-alerta lx-alerta--error" role="alert" #alertaAplicar *ngIf="errorEn === 'aplicar' && mensajeError">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo">No pudimos aceptar tu oferta</p>
          <p class="lx-alerta__texto">{{mensajeError}}</p>
          <button type="button" class="lx-btn lx-btn--secundario lx-btn--chico lx-btn--auto lx-alerta__accion" (click)="calculateOffers()">
            <fa-icon [icon]="iconos.reintentar" aria-hidden="true"></fa-icon><span>Volver a calcular</span>
          </button>
        </div>
      </div>

      <p class="lx-seguro">
        <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
        <span>Calcular no te compromete: la oferta solo se aplica cuando la aceptas.</span>
      </p>
    </form>

    <!-- Una sola acción principal, fija abajo: calcular o aceptar -->
    <div class="lx-cta-fijo">
      <ng-container *ngIf="!offers.length; else ctaAceptar">
        <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="calculando" [attr.aria-busy]="calculando"
                [disabled]="!entity.get('amount')?.valid && !calculando" (click)="calculateOffers()">
          <span class="lx-spinner" *ngIf="calculando; else iconoCalcular" aria-hidden="true"></span>
          <ng-template #iconoCalcular><fa-icon [icon]="iconos.calcular" aria-hidden="true"></fa-icon></ng-template>
          <span>{{calculando ? 'Calculando tus opciones…' : textoCalcular}}</span>
        </button>
        <p class="lx-cta-fijo__nota">Te mostramos cuánto pagarías en cada plazo.</p>
      </ng-container>
      <ng-template #ctaAceptar>
        <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="aplicando" [attr.aria-busy]="aplicando"
                [disabled]="(!elegida || entity.invalid) && !aplicando" (click)="applyForOffer()">
          <span class="lx-spinner" *ngIf="aplicando" aria-hidden="true"></span>
          <span>{{aplicando ? 'Aceptando tu oferta…' : textoAceptar}}</span>
        </button>
        <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.seguro" aria-hidden="true"></fa-icon>Solo se aplica cuando aceptas.</p>
      </ng-template>
    </div>
  </ng-container>

  <!-- Sin capacidad de pago -->
  <ng-template #elseComment>
    <section class="lx-pagina" lang="es">
      <header class="lx-hero">
        <div class="lx-hero__cabeza">
          <span class="lx-hero__icono lx-hero__icono--navy" aria-hidden="true"><fa-icon [icon]="iconos.oferta"></fa-icon></span>
          <div class="lx-hero__textos">
            <span class="lx-hero__eyebrow">Tu oferta</span>
            <h2 class="lx-hero__titulo">Por ahora no podemos ofrecerte un crédito</h2>
            <p class="lx-hero__subtitulo">Tu capacidad de pago de hoy no alcanza para un crédito. No es definitivo.</p>
          </div>
        </div>
      </header>
      <section class="lx-tarjeta" aria-labelledby="ofr-que-hacer">
        <h3 class="lx-tarjeta__titulo" id="ofr-que-hacer">¿Qué puedes hacer?</h3>
        <ol class="lx-lista lx-lista--numerada" style="margin-top: 12px">
          <li>Inténtalo de nuevo en 30 días: tu capacidad de pago puede cambiar.</li>
          <li>Si crees que hay un error, contáctanos a soporte.</li>
        </ol>
        <div class="lx-cta" style="margin-top: 18px">
          <button type="button" class="lx-btn lx-btn--primario" (click)="understand()"><span>Lo entiendo</span></button>
        </div>
      </section>
    </section>
  </ng-template>
</ng-container>
